module.exports = __webpack_public_path__ + "img/saudi-arabia.417e6ec5.svg";